/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.draws.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * A draw rule condition.
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class DrawRuleCondition(
    /** Unique draw rule condition id. */
    @SerialName("id")
    val id: Int?,

    /** The draw rule condition title. */
    @SerialName("title")
    val title: String?,

    /** The draw rule condition description. */
    @SerialName("description")
    val description: String?,

    @SerialName("languages")
    val languages: List<Languages>?
)
